//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { userSettingsManager } from './UserSettingsManager.js'

export default {
  mixins: [userSettingsManager],
  data: function () {
    return {
      booleanListValues: [
        { name: 'Да', value: true },
        { name: 'Нет', value: false }
      ],
      loading: false,
      settings: {}
    }
  },
  created: function () {
    this.load()
  },
  methods: {
    getIconName: function (setting) {
      if (setting.code === 'ui.common.coordinateOrder') {
        return 'mdi-crosshairs-gps'
      } else if (setting.code === 'ui.common.view') {
        return 'mdi-cellphone-link'
      } else if (setting.code === 'ui.common.dispatcherObjectCardView') {
        return 'mdi-border-all'
      }
      return 'mdi-cogs'
    },
    load: function () {
      this.loading = true

      return this.loadUserSettings()
        .then(settings => {
          Object.values(settings).forEach(config => {
            config.valueInitial = config.value
            config.icon = this.getIconName(config)

            if (config.type === 'boolean') {
              config.listvalues = this.booleanListValues
            }
          })
          this.settings = settings
        })
        .finally(() => {
          this.loading = false
        })
    },
    onSave: function () {
      const changedSettingsData = {}
      for (const [key, config] of Object.entries(this.settings)) {
        // TODO проверка для всех типов значений, не только listvalue и boolean
        if (config.value !== config.valueInitial) {
          changedSettingsData[key] = config.value
        }
      }
      if (Object.keys(changedSettingsData).length === 0) {
        this.$q.notify({
          type: 'warning',
          message: 'Нет изменений',
          progress: true,
          timeout: 3000
        })
        return
      }

      this.loading = true
      this.saveUserSettings(changedSettingsData)
        .then(() => {
          Object.values(this.settings).forEach(config => {
            config.valueInitial = config.value
          })
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}

